<template>
    <!-- 疫情防控 -->
    <div class="inside_pages_box" >
		<div class="row inside_pages_content">
            <!-- <LeftMenu></LeftMenu> -->
            <router-view/>
        </div>
	</div>
</template>

<script>
import LeftMenu from '@/components/LeftMenu'
export default {
    name:'',
    components: {LeftMenu},
    props: {},
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {},
    mounted() {
    }
};
</script>
<style scoped>
</style>